import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Link } from 'react-router-dom';
import { capitalize, formatDate } from '../../../utils';
import { APPLICATION_STATUS, PAYMENT_STATUS } from '../../../constants/event-application-status';
import { APP_ROUTES } from '../../../constants/app-routes';

export default function Row({ key, row }) {
  const { event, vendor } = row;

  const formatStatus = (status) => {
    if (status === PAYMENT_STATUS.BALANCE_DUE) {
      return 'Balance Due';
    }

    return capitalize(status);
  };

  return (
    <TableRow key={key} sx={{ '& > *': { borderBottom: 'unset' } }}>
      <TableCell align="left">{event?.name}</TableCell>
      <TableCell align="left">{event?.venue?.name}</TableCell>
      <TableCell align="left">
        <Link to={APP_ROUTES.VENDOR_PUBLIC_PROFILE.replace(':vendorId', vendor.id)}>
          {vendor?.name} {vendor?.last_name}
        </Link>
      </TableCell>
      <TableCell align="left">{vendor?.email}</TableCell>
      <TableCell align="left">{capitalize(row.application_status ?? '')}</TableCell>
      <TableCell align="left">
        {row.application_status === APPLICATION_STATUS.APPROVED && formatStatus(row?.status ?? '')}
      </TableCell>
      <TableCell align="left">{event?.parameters_event?.event_date}</TableCell>
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.instanceOf(Object).isRequired,
  key: PropTypes.number.isRequired,
};
